interface ConditionalWrapperProps {
  condition: boolean
  renderIfTrue: (children: React.ReactElement) => JSX.Element
  renderIfFalse: (children: React.ReactElement) => JSX.Element
  children: React.ReactElement
}

export const ConditionalWrapper = ({
  condition,
  renderIfTrue,
  renderIfFalse,
  children,
}: ConditionalWrapperProps) =>
  condition ? renderIfTrue(children) : renderIfFalse(children)

export default ConditionalWrapper
